// @flow
import { OtherDataContactsActionTypes } from './constants';

type OtherDataContactsAction = { type: string, payload: {} | string };

// common success
export const otherDataContactsApiResponseSuccess = (actionType: string, data: any): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const otherDataContactsApiResponseError = (actionType: string, error: string): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getOtherDataContact = (id: string): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.GET_OTHER_DATA_CONTACTS,
    payload: { id },
});

export const addOtherDataContact = (otherDataContact: any): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.ADD_OTHER_DATA_CONTACTS,
    payload: otherDataContact
})
export const updateOtherDataContact = (otherDataContact: any): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.UPDATE_OTHER_DATA_CONTACTS,
    payload: otherDataContact
})
export const deleteOtherDataContact = (id: string): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.DELETE_OTHER_DATA_CONTACTS,
    payload: { id }
})

export const listOtherDataContacts = (params: any): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.LIST_OTHER_DATA_CONTACTS,
    payload: params,
});


export const resetOtherDataContacts = (): OtherDataContactsAction => ({
    type: OtherDataContactsActionTypes.RESET,
    payload: {},
});

